module.exports = __webpack_public_path__ + "static/media/flights.89c1c144.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/img/flights.jpg
// module id = 436
// module chunks = 0